// getParentFieldName takes 'foo[0].bar' or 'foo.bar' format to return ['foo', 'bar']
export const getParentFieldName = (name: string): string[] => name.split(/\[\d]\.|\[\d]|\./);
